import {Action} from "redux";
import {CategoryManagerAction, isCategoryManagerAction} from "./actions";
import {CategoryId} from "./data";

export type CategoryManagerState = {
	selectedCategories: CategoryId[]
}

export const reducer = (s: CategoryManagerState, a: Action): CategoryManagerState => {
	if(isCategoryManagerAction(a)) {
		return categoryManagerReducer(s, a.action)
	}
	return s
}

export const categoryManagerReducer = (s: CategoryManagerState, a: CategoryManagerAction): CategoryManagerState => {
	switch (a.type) {
		case "set category checkbox":
			const v: (string|number)[] = [a.value]
			return {...s, selectedCategories: v.concat(s.selectedCategories)}
		case "unset category checkbox":
			return {...s, selectedCategories: s.selectedCategories.filter(cid => cid != a.value)}
	}
}



// WEBPACK FOOTER //
// ./src/lib/category-manager/reducers.ts